import React, { useEffect, useRef, useContext } from "react";
import UserProgressContext from "../../userProgressContext";

const MENU_ITEMS = [
  { id: "name", label: "Change Name", icon: "✏️" },
  { id: "email", label: "Change Email", icon: "📧" },
];

const PlayerMenuDropdown = ({ onSelect, onClose }) => {
  const { name } = useContext(UserProgressContext);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div
      ref={dropdownRef}
      className="absolute right-0 top-full mt-2 w-52 bg-cyber-bg border border-cyber-dim rounded-lg shadow-2xl z-[100] overflow-hidden"
    >
      {name && (
        <div className="px-4 py-2.5 border-b border-cyber-dim">
          <p className="text-xs text-cyber-sub uppercase tracking-widest">Signed in as</p>
          <p className="text-sm font-bold text-cyber-accent tracking-wider truncate">{name}</p>
        </div>
      )}
      <ul className="py-1">
        {MENU_ITEMS.map((item) => (
          <li key={item.id}>
            <button
              onClick={() => onSelect(item.id)}
              className="w-full text-left flex items-center gap-3 px-4 py-3 text-sm text-cyber-text hover:bg-cyber-panel hover:text-cyber-accent transition-colors duration-150 tracking-wide"
            >
              <span className="text-base">{item.icon}</span>
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PlayerMenuDropdown;
